// Device selectors live here.

// Base selector for device slice state.
export const selectDeviceState = (state) => state.device;

export const selectSelectedDeviceId = (state) => selectDeviceState(state).selectedDeviceId;

export const selectSelectedDeviceIndex = (state) => selectDeviceState(state).selectedDeviceIndex;

export const selectUpdatedSelectedDevice = (state) =>
  selectDeviceState(state).updatedSelectedDevice;

export const selectSelectedGroupId = (state) => selectDeviceState(state).selectedGroupId;

export const selectLinkingGroupId = (state) => selectDeviceState(state).linkingGroupId;

export const selectDeviceSettings = (state) => selectDeviceState(state).deviceSettings;

export const selectGroupSettings = (state) => selectDeviceState(state).groupSettings;

export const selectAwareOpen = (state) => selectDeviceState(state).awareOpen;

export const selectUSGSOpen = (state) => selectDeviceState(state).usgsOpen;

export const selectUSGSDisclaimerAccepted = (state) =>
  selectDeviceState(state).usgsDisclaimerAccepted;
